import React from "react";
import { Doughnut } from "react-chartjs-2";
import { getBrandingChartPalette } from "../utils/brandingThemeColor";

const LinkLandingPageTooDeviceTypes = ({ topDeviceCategoriesData }) => {
  const segmentCount = topDeviceCategoriesData?.data?.length || 0;
  const brandingColors = getBrandingChartPalette(segmentCount);

  const doughnutData = {
    labels: topDeviceCategoriesData.labels,
    datasets: [
      {
        data: topDeviceCategoriesData.data,
        backgroundColor: brandingColors,
        hoverBackgroundColor: brandingColors,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    type: "doughnut",
    align: "start",
    position: "top",
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label(context) {
            const label = context.label || "";
            const usage = context.raw || "";
            return `${label}: ${usage} %`;
          },
        },
      },
    },
  };

  return (
    <>
      <div className="chart-wrapper" style={{ width: "100%", margin: "0 auto", height: 300 }}>
        <Doughnut data={doughnutData} options={options} />
      </div>
    </>
  );
};

export default LinkLandingPageTooDeviceTypes;
